
import { styled } from "@mui/material/styles"
import { SnackbarProvider,closeSnackbar } from "notistack"
import Button from "@mui/material/Button"
import { useSelector } from "react-redux"
import { SnackbarUtilsConfigurator } from "../../../common/toastNotistack"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ReportIcon from '@mui/icons-material/Report';

import InfoIcon from '@mui/icons-material/Info';


const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  "&.SnackbarItem-variantError": {
    backgroundColor: theme.palette.error.main
  },
  "&.SnackbarItem-variantSuccess": {
    backgroundColor: theme.palette.success.main
  },
  "&.SnackbarItem-variant": {
    backgroundColor: theme.palette.success.main
  },
  "&.SnackbarItem-variantInfo": {
    backgroundColor: theme.palette.info.main
  },
  "&.SnackbarItem-variantWarning": {
    backgroundColor: theme.palette.warning.light
  }
}))

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

const Notistack = ({ children }) => {
  const snackbar = useSelector(state => state.snackbar)
  const iconSX = { marginRight: 1, fontSize: "1.15rem" }

  return (
    <StyledSnackbarProvider
    autoHideDuration={5000}
    anchorOrigin={{horizontal: "center", vertical: "top"}}
      maxSnack={3}
      dense={snackbar.dense}
      action={(snackbarId) => {
        <button variant='text' sx={{color:'#fff'}} onClick={()=>closeSnackbar(snackbarId)}>
            Dismiss
            </button>}}
      iconVariant={
        snackbar.iconVariant === "useemojis"
          ? {
              success: <CheckCircleOutlineIcon sx={iconSX} />,
              error: <HighlightOffIcon sx={iconSX} />,
              warning: <ReportIcon sx={iconSX} />,
              info: <InfoIcon sx={iconSX} />
            }
          : undefined
      }
      hideIconVariant={snackbar.iconVariant === "hide" ? true : false}
    >
      <SnackbarUtilsConfigurator />
    
      {children}
    </StyledSnackbarProvider>
  )
}

export default Notistack
